import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { editorSlice } from "#/features/treeViewer/model/editorSlice";
import { useAppDispatch } from "#/store/hooks";

/**
 * Landing hero preview: keep tree layout CSS transitions unless the user has
 * prefers-reduced-motion: reduce.
 */
export const useLandingHeroPreviewLayoutTransitions = () => {
  const $ = _c(3);
  const dispatch = useAppDispatch();
  let t0;
  let t1;
  if ($[0] !== dispatch) {
    t0 = () => {
      if (typeof window.matchMedia !== "function") {
        return;
      }
      const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      const syncLayoutTransitions = () => {
        dispatch(editorSlice.actions.setDisableLayoutTransitions(mediaQuery.matches));
      };
      syncLayoutTransitions();
      mediaQuery.addEventListener("change", syncLayoutTransitions);
      return () => {
        mediaQuery.removeEventListener("change", syncLayoutTransitions);
      };
    };
    t1 = [dispatch];
    $[0] = dispatch;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};